import {h, Fragment} from "preact"
import { useContext, useEffect, useState } from "preact/hooks";
import { createContext } from "preact";

const FiltersPanelStateContext = createContext();

const useFiltersPanelState = () => {
  return useContext(FiltersPanelStateContext);
};


const FiltersPanelStateProvider = ({ children }) => {
  
    const [isOpen, setIsOpen] = useState(false)
  
    return (
      <FiltersPanelStateContext.Provider
        value={{
            isFiltersOpen: isOpen,
            openFilters: setIsOpen
        }}
      >
        {children}
      </FiltersPanelStateContext.Provider>
    );
};


export { FiltersPanelStateProvider, useFiltersPanelState };